<template>
  <v-card v-if="ies_year_data" class="fill-height">
    <DashboardBar
      :title="!in_loading && curr_ies
        ? `${curr_ies.siglas } - ${ies_year_data.year}`
        :'Cargando...'"
    />
    <HelpDataIes :is_middle="is_middle" :is_ies="is_ies"/>
    <v-subheader>Nota General:</v-subheader>
    <v-col cols="12" class="pt-0 px-0">
      <v-card color="amber lighten-5">
        <v-card-text>
          <v-textarea
            v-if="edit_note"
            label="Nota general sobre el registro del Periodo actual"
            v-model="ies_year_data.register_referance.nota"
            :rules="[v => !!v || 'Requiere que escribas algo']"
            auto-grow
          ></v-textarea>
          <span v-else v-text="ies_year_data.register_referance.nota" class="note">
          </span>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn v-if="edit_note" color="success" @click="save_note">
            Guardar
          </v-btn>
          <v-btn v-else color="accent" outlined @click="edit_note = true">
            Editar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-col>

    <v-subheader>{{is_middle ? 'Ejes:' : 'Secciones:'}}</v-subheader>
    <v-expansion-panels multiple focusable class="pa-2" v-if="!is_middle">
      <v-expansion-panel class="mb-2" v-for="section in real_sections">
        <v-expansion-panel-header>
          <v-row class="px-2">
            <IconStatus :status="section.status"/>
            <v-col class="pa-0">
              <b class="ml-3 headline">{{section.name}}</b>
              <span class="grey--text" align="center" v-if="section.key == 'pob'"> 
                Utilizar datos del último ciclo académico iniciado en {{ies_year_data.year}}
              </span>
            </v-col>
          </v-row>
        </v-expansion-panel-header>
        <v-expansion-panel-content class="py-2" v-if="section.key == 'base'">
          <BaseInfo/>
        </v-expansion-panel-content>
        <v-expansion-panel-content class="pt-2" v-else-if="section.key == 'ejes'">
          <v-expansion-panels multiple >
            <v-expansion-panel v-for="eje in real_ejes">
              <v-expansion-panel-header>
                <div>
                  <IconStatus :status="eje.status"/>
                  <b class="ml-3">{{eje.nombre_corto}} </b> 
                  <span class="grey--text">{{eje.nombre}}</span>
                </div>
              </v-expansion-panel-header>
              <v-expansion-panel-content>
                <div 
                  class="mx-n2"
                  v-for="indicador in indicadores.filter(d => d.eje_id == eje.id)"
                >
                  <h3 class="headline py-3">{{indicador.nombre}}</h3>
                    <Question 
                      v-for="resp in respuestas.filter(r=>r.indicador_id == indicador.id)"
                      :resp="resp" 
                      :indicador="indicador"
                      :ies_year_data="ies_year_data"
                    />
                  <v-divider class="darks"></v-divider>
                </div>
              </v-expansion-panel-content>
            </v-expansion-panel>
          </v-expansion-panels>
        </v-expansion-panel-content>
        <v-expansion-panel-content class="pt-2" v-if="section.key == 'pob'">
          <v-expansion-panels multiple >
            <v-expansion-panel v-for="g_pob in g_poblacion">
              <v-expansion-panel-header>
                <div>
                  <IconStatus :status="g_pob.status"/>
                  <span class="ml-3">{{g_pob.grupo_segmento.tipo.nombre}} - <b>{{g_pob.grupo_segmento.nombre}}</b></span>
                </div>
              </v-expansion-panel-header>
              <v-expansion-panel-content>
                <GrupoSegmento :g_seg="g_pob"/>
              </v-expansion-panel-content>
            </v-expansion-panel>
          </v-expansion-panels>
        </v-expansion-panel-content>
        <v-expansion-panel-content v-if="section.key == 'extra'">
          <AditionalData  
            :period_ies="ies_year_data" 
            :data_ad="ies_year_data.register_referance.aditional_data"
          />
        </v-expansion-panel-content>
      </v-expansion-panel>
    </v-expansion-panels>


    <v-card class="ma-3" v-else v-for="eje in questions_middle">
      <v-sheet class="pa-2" color="grey lighten-2" tile>
        <b>{{eje.nombre_corto}} </b> 
        <span class="grey--text">{{eje.nombre}}</span>
      </v-sheet>
      <v-divider></v-divider>
      <div v-for="indicador in eje.indicadores" class="pa-2">
        <h3 class="headline py-3 px-3">{{indicador.nombre}}</h3>
        <Question 
          v-for="resp in indicador.respuestas"        
          :resp="resp"
          :indicador="{}"
          :ies_year_data="ies_year_data"
        />            
      </div>
    </v-card>

    <v-subheader>
      <v-spacer></v-spacer>
      <span v-if="is_ies">Cuando completes la información, envíala a revisión:</span>
      <span v-else>Cuando completes la revisión, decide el siguiente paso:</span>
    </v-subheader>
    <v-card-actions>
      <v-spacer></v-spacer>
      <v-btn 
        elevation="5"
        class="mb-2 px-3 mx-3" 
        color="accent"
        large
        @click="send_all_data()"
      >
        {{is_ies ? 'Enviar a Revisión' : 'Enviar a Corrección'}}
      </v-btn>
      <v-btn 
        v-if="!is_ies"
        elevation="5"
        class="mb-2 px-3 mx-3" 
        color="success"
        large
        @click="send_all_data(true)"
      >
        Aprobar IES
      </v-btn>
    </v-card-actions>
    <v-dialog
      v-model="dialog_send"
      max-width="520"
    >
      <v-card>
        <v-card-title class="headline no-wrap text-center">
          <span>
            <v-icon v-if="data_complete" color="blue">info</v-icon>
            <v-icon v-else color="red">warning</v-icon>
            {{send_dialog[`title_${data_complete?'':'in'}complete`]}}
          </span>
        </v-card-title>
        <v-card-text class="note black--text">
          {{send_dialog[`subtitle_${data_complete?'':'in'}complete`]}}
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <template v-if="data_complete">
            <v-btn
              color="primary"
              outlined
              @click="dialog_send=false"
            >
              Regresar
            </v-btn>
            <v-btn
              color="primary"
              @click="save_all_data()"
            >
              <!--dialog_comment = true-->
              Enviar a Revisión
            </v-btn>
          </template>
          <v-btn
            color="primary"
            text
            v-else
            @click="dialog_send=false"
          >
            Regresar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog
      v-model="dialog_send_note"
      max-width="520"
    >
      <v-card>
        <v-card-title class="headline no-wrap text-center">
          <span>
            <v-icon v-if="data_complete" color="blue">info</v-icon>
            Si tienes otras observaciones, edita la nota general
          </span>
        </v-card-title>
        <v-card-text class="note black--text">
          <v-textarea
            label="Nota general sobre el registro del Periodo actual"
            v-model="ies_year_data.register_referance.nota"
            auto-grow
          ></v-textarea>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="accent"
            @click="save_all_data()"
          >
            Enviar a corrección
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-card>
</template>

<script>

import { mapState } from "vuex";
import router from "@/router.js";
import Question from "@/components/dashboard/questions/Question.vue";
import GrupoSegmento from "@/components/dashboard/questions/GrupoSegmento.vue";
import BaseInfo from "@/components/dashboard/questions/BaseInfo.vue";
import DashboardBar from "@/components/dashboard/DashboardBar.vue";
import HelpDataIes from "@/components/dashboard/helpers/HelpDataIes.vue";
import AditionalData from "@/components/dashboard/questions/AditionalData.vue";
import IconStatus from "@/components/dashboard/helpers/IconStatus.vue";

export default {
  name: 'PeriodIes',
  components: {
      Question,
      GrupoSegmento,
      DashboardBar,
      BaseInfo,
      HelpDataIes,
      AditionalData,
      IconStatus,
  },
  data(){
    return {
      loading: true,
      dialog_send: false,
      dialog_send_note: false,
      edit_note: false,
      curr_ies: undefined,
      send_dialog:{
        title_complete: '¿Estás seguro de enviar tu información?',
        subtitle_complete: 'La información que se apruebe, no podrá ser cambiada después. \n \n La información será pública sólo si es validada \n \n Si se  encuentran inconsistencias, deberás corregir la información\n \n Puedes previsualizar tu información antes de enviarla',
        title_incomplete: 'Completa todas las secciones para poder enviar tu información',
        subtitle_incomplete: 'Las secciones no pueden quedar incompletas',
      },
      data_complete: false,
      sections:[
        {
          "name":"Información Base",
          "key":"base",
          "status":{},
        },
        {
          "name":"Ejes e Indicadores",
          "key":"ejes",
          "status":{},
        },
        {
          "name":"Población (Eje Igualdad)",
          "key":"pob",
          "status":{},
        },
        {
          "name":"Información Adicional",
          "key":"extra",
          "status":{},
        },
      ],
      action_buttons:[
        {name:'init_register', text:'Comenzar registro'},
        //{name:'send_to_review', text:'Enviar a Revisión'},
        {name:'modify_data', text:'Corregir Información', action:'goTo'},
        {name:'register_advances', text:'Registrar avances'},
      ],
    }
  },
  methods:{
    save_note(){
      let period_id = this.ies_year_data.ies_period_id
      this.$store
        .dispatch('UPDATE_PERIOD_IES_BASE', {
          data: {nota: this.ies_year_data.register_referance.nota},
          snack_text: '¡Se ha editado tu nota!', 
          period_ies_id: period_id
        })
        .then((data) => {
          this.edit_note = false
        })
        .catch(error =>{
          console.log(error)
          this.edit_note = false
        });

    },
    calc_status_repuestas(respuestas, test=false) {
      if (test)
        console.log(this.calc_status_name(respuestas, test))
      var status_name = this.calc_status_name(respuestas)
      var status_obj = this.all_status.find(d=>d.name == status_name)
      return status_obj
    },
    calc_status_name(respuestas, test=false){
      
      //console.log(this.ies_status.name)
      //console.log(this.ies_year_data.stage)

      if (this.ies_status.name == 'in_review'){
        //console.log("opción 1")
        var sum = respuestas.reduce((obj, x)=>{
          obj.sent_admin += x.status.send_admin;
          return obj
        }, {sent_admin:0})
        sum["total"] = respuestas.length;
        if (sum.sent_admin == 0)
          return "missing"
        else if (sum.total == sum.sent_admin)
          return "complete"
        else if (sum.sent_admin > 0)
          return "incomplete"
        else
          return "error"
      }
      else if (this.ies_year_data.stage == 'final' 
        && (this.ies_status.name == 'in_register' 
          || this.ies_status.name == 'need_changes')){
        //console.log("opción 2")
        var sum = respuestas.filter(x=> x.status.name != 'missing')
          .reduce((obj, x)=>{
          obj.strict_ies += x.status.strict_ies;
          obj.sent_ies += x.status.send_ies;
          return obj
        }, {strict_ies:0, sent_ies:0})
        sum["total"] = respuestas.length;
        if (sum.sent_ies == 0)
          return "missing"
        else if (sum.total == sum.strict_ies)
          return "complete"
        else if (sum.sent_ies > 0) // && sum.sent_ies < sum.total)
          return "incomplete"
        else
          return "error"
      }
      else if (this.ies_year_data.stage == 'final' 
        && this.ies_status.name == 'in_changes'){
        //console.log("ESTOY EN CAMBIOS")
        var sum = respuestas.filter(x=> x.status.name != 'need_changes')
          .reduce((obj, x)=>{
          var r_status = x.status
          obj.corrected += (r_status.name == 'corrected');
          obj.sent_ies += r_status.send_ies;
          return obj
        }, {corrected:0, sent_ies:0})
        if(test){
          console.log(sum)
          console.log(respuestas.length)
        }
        sum["total"] = respuestas.length;
        if (sum.total > sum.sent_ies)
          return "need_changes"
        else if (sum.sent_ies == sum.total){
          if (sum.corrected > 0)
            return "corrected"
          else
            return "validated"
        }
        else if (sum.sent_ies == sum.total)
          return "corrected"
        else
          return "no encontrado (cambios)"
      }
      else if (this.ies_year_data.stage == 'middle'
        && (this.ies_status.name == 'in_register' 
          || this.ies_status.name == "in_changes")){
        var sum = respuestas.reduce((obj, x)=>{
          var r_status = x.status
          obj.has_improves += (r_status.name == 'has_improves');
          obj.can_improve += (r_status.name == 'can_improve');
          obj.complete += (r_status.name == 'complete');
          obj.published += (r_status.name == 'published');
          return obj
        }, {has_improves: 0, can_improve:0, complete:0, 
            al_complete:0, published:0})
        sum["total"] = respuestas.length;
        if ((sum.complete + sum.al_complete)  == 0){
          if (sum.can_improve > 0)
            return "can_improve"
          else if (sum.published > 0)
            return "published"
          else
            return "complete"
        }
        else if (sum.has_improves)
          return "has_improves"
        else
          return "no encontrado (middle)"
      }
      else
        return "DESCONOCIDO"
      /*        
        else if (this.ies_status == 'with_data'){
          var sum = respuestas.reduce((obj, x)=>{
            var r_status = x.status
            obj.need_changes += (r_status.name == 'need_changes');
            obj.validated += (r_status.name == 'validated');
            obj.corrected += (r_status.name == 'corrected');
            obj.complete += (r_status.name == 'complete');
            obj.al_complete += (r_status.name == 'almost_complete');
            obj.strict_ies += r_status.strict_ies;
            obj.sent_ies += r_status.send_ies;
            return obj
          }, {need_changes: 0, validated:0, corrected:0, complete:0, 
              al_complete:0, strict_ies:0, sent_ies:0})
          sum["total"] = respuestas.length;
          if (sum.sent_ies == 0)
            return "missing"
          else if (sum.total == sum.strict_ies)
            return "complete"
          else if (sum.sent_ies == sum.total) // && sum.strict_ies < sum.total)
            return "almost_complete"
          else if (sum.sent_ies > 0) // && sum.sent_ies < sum.total)
            return "incomplete"
          else
            return "no encontrado"
        }*/
    },
    send_all_data(aproved = false){
      if (this.is_middle){
        //console.log(this.questions_middle)
        //console.log(this.calc_status_repuestas(this.respuestas))
        var has_enhace = this.questions_middle.find(eje=>
          eje.indicadores.find(ind=>
            ind.respuestas.find(r=>
              r.vertical_value == 1 && 
              r.status[this.is_ies ? 'send_ies' : 'send_admin'])))
        //console.log(has_enhace)
        if (has_enhace){
          if (this.is_ies){
            this.data_complete = true
            this.dialog_send = true
          }
          else{
            if (aproved)
              this.save_all_data(aproved)
            else
              this.dialog_send_note = true
          }
        }
        else{
          this.data_complete = false
          this.dialog_send = true
        }
      }
      else{
        var strict_count = this.real_sections.filter(x=> x.status.strict_ies).length
        //Cuando una revisora completó las 4 secciones
        if (strict_count == 4){
          if (aproved)
            this.save_all_data(aproved)
          else
            this.dialog_send_note = true
        }
        else{
          var complete_count = this.real_sections.filter(x=> x.status.send_ies).length
          if (complete_count == 4){
            this.dialog_send = true
            this.data_complete = true
          }
          else if (complete_count > 1){
            this.dialog_send = true
          }
        }
      }
    },
    save_all_data(aproved = false){
      var st_name = 'in_review'
      if (!this.is_ies)
        st_name = aproved ? (this.is_middle ? 'middle_data' : 'with_data') 
          : 'need_changes'
      var new_status =  this.status_ies.find(d=>d.name == st_name)
      //console.log(new_status)
      let period_id = this.ies_year_data.ies_period_id
      var snack_text = this.is_ies 
        ? '¡Tus datos han sido enviados!, espera la revisión'
        : '¡La revisión se ha guardado correctamente'
      this.$store
        .dispatch('UPDATE_PERIOD_IES_BASE', {
          data: {status_registro: new_status.id, snack_text: snack_text,
            nota: this.ies_year_data.register_referance.nota}, 
            period_ies_id: period_id, snack_text: snack_text}
        ).then((data) => {
          //console.log(data)
          if (this.is_ies)
            router.replace({name: 'IESHome', params:  {'ies_id': this.ies_year_data.ies_id}})
          else
            router.replace({name: 'ReviewerHome', params: {'year': this.ies_year_data.year}})
          this.dialog_send = false
        })
        .catch(error =>
          console.log(error)
        );
    },
    get_status(status_name){
      return this.ejes && this.all_status
        ? this.all_status.find(d=>d.name == status_name)
        : {}
    },

  },
  computed:{
    ...mapState({
      ies_year_data: state => state.ies_year_data,
      ies_data: state => state.ies_data,
      ejes: state => state.ies_year_data.data.ejes.ejes,
      indicadores: state => state.ies_year_data.data.ejes.indicadores,
      respuestas: state => state.ies_year_data.data.ejes.respuestas,
      ies_status: state => state.ies_year_data.register_referance.status,
      all_status: state => state.all_status,
      g_poblacion: state => state.ies_year_data.data.grupo_poblacion,
      in_loading: state => state.in_loading,
      status_ies: state => state.status_ies,
      is_ies: state => state.is_ies,
      is_middle: state => state.ies_year_data.stage == 'middle',
      current_period_detail: state => state.current_period_detail,
    }),
    questions_middle(){
      var resp = this.respuestas.filter(r=>r.pregunta.previous_value < 1)
      var indicadores = this.indicadores.map(ind=>{
        ind.respuestas = resp.filter(r=>r.indicador_id==ind.id)
        return ind
      })
      indicadores = indicadores.filter(ind=>ind.respuestas.length)
      var ejes = this.ejes.map(eje=>{
        eje.indicadores = indicadores.filter(ind=>ind.eje_id==eje.id)
        return eje
      })
      return ejes.filter(eje=>eje.indicadores.length)
    },
    real_ejes(){
      return (this.ejes && this.all_status && this.respuestas)
        ? this.ejes.map(eje=>{
          var respuestas = this.respuestas.filter(d => d.eje_id == eje.id)
          eje.status = this.get_status(this.calc_status_name(respuestas))
          return eje
        })
        : this.ejes
    },
    real_sections(){
      let complete = this.ejes && this.all_status
      var refer = this.ies_year_data.register_referance
      var complete_status = this.get_status('complete')
      let status_base = complete
        ? (!!refer.ent_acad && !!refer.dep_admin && !!refer.planes_est)
          ? refer.organigrama_name ? 'complete' : 'need_file'
          : 'missing'
        : {}
      let status_ejes = complete
        ? this.calc_status_repuestas(this.respuestas)
        : {}
      let status_pob = complete
        ? this.ies_status.name == 'in_review' 
          || this.ies_status.name == 'need_changes'
          ? complete_status 
          : this.calc_status_repuestas(this.g_poblacion)
        : {}
      return [
        {
          "name": "Información Base",
          "key": "base",
          "status": this.get_status(status_base)
        },
        {
          "name": "Ejes e Indicadores",
          "key": "ejes",
          "status": status_ejes,
        },
        {
          "name":"Población (Eje Igualdad)",
          "key":"pob",
          "status": status_pob,
        },
        {
          "name":"Información Adicional",
          "key":"extra",
          "status": complete_status,
        },
      ]
    },
  },
  created(){
    this.$store.dispatch('FETCH_STATUS_RESPUESTAS')
    this.loading=true;
    this.$store.dispatch('GET_YEAR_IES_DATA', 
      router.currentRoute.params.period_ies_id).then(()=>{
        //console.log(this.current_period_detail)
        //console.log(this.ies_year_data)
        this.curr_ies = this.ies_data || this.current_period_detail.ies.find(ie=>
          ie.id==this.ies_year_data.ies_id)
        /*RICK if (!this.is_ies && (this.ies_status != 'in_review' || this.ies_status != 'with_data'))
          router.push({ name: 'ReviewerHome' })*/
        this.loading=false;

      })
  },
}
</script>

<style scoped>
.darks{
  border-color: black !important;
}

</style>